// Project Imports
import Product from "constants/ProductConstants";

const fetchChildBenefit = (solutionData) => {
  let childBenefitApplicable = false;
  let lifeCoverMsg = [];
  solutionData.coverage.forEach((coverage) => {
    coverage.life_assured_list.forEach((lifeAssured) => {
      lifeAssured.product_details.forEach((obj) => {
        switch (obj.product_name) {
          case Product.FAMILY_PROTECTION_OPTION_SMART_LIFESTYLE:
          case Product.CHILD_VARIANT_WEALTH_SECURE_PLUS:
            lifeCoverMsg.push(
              "In case of death of Life Insured, future premiums are waived off and all benefits will continue to be paid."
            );
            break;

          case Product.SECURED_INCOME_OPTION_INCOME_BUILDER:
            lifeCoverMsg.push(
              "In case policy holder is diagnosed with covered Critical Illnesses or death of policyholder, future premiums are waived off and all benefits will continue to be paid."
            );
            break;

          case Product.LITTLE_CHAMP_WEALTH_ULTIMA:
          case Product.RISING_STAR_WEALTH_PLUS:
          case Product.GUARANTEED_INCOME_STAR_FIB:
          case Product.NEW_GUARANTEED_INCOME_STAR_NON_PAR_FIB:
          case Product.GUARANTEED_SAVINGS_STAR_LUMPSUM_FIB:
          case Product.GUARANTEED_SAVINGS_STAR_INCOME_FIB:
            lifeCoverMsg.push(
              "In case of death of policyholder, future premiums are waived off and all benefits will continue to be paid."
            );
            break;

          case Product.ACTIVE_INCOME_PLAN_WITH_FIB:
            lifeCoverMsg.push(
              "In  case of diagnosis of critical illness or death of policyholder, future premiums are waived off and all benefits will continue to be paid."
            );
            break;

          // FIB Product Removed  
          // case Product.PREMIER_GUARANTEED_INCOME_LUMPSUM_FIB:
          // case Product.PREMIER_GUARANTEED_SHORT_TERM_INCOME_FIB:
          // case Product.PREMIER_GUARANTEED_LONG_TERM_INCOME_FIB:
          //     break;
        }
      });
    });
  });

  return lifeCoverMsg;
};

export default fetchChildBenefit;
